import { fullExpiryYear } from './field-validation.js';

export { fullExpiryYear };

export function formatCardNumberInput(input) {
    const $input = window.jQuery(input);
    const last = $input.val().slice(-1);
    if (isNaN(last) && last !== '') {
        $input.val($input.val().slice(0, -1));
        return;
    }
    const digits = $input.val().replace(/\s/g, '');
    if (/^3[47]\d{2}/.test(digits)) {
        $input.val(
            digits
                .replace(/(\d{4})\s*(\d{6})?\s*(\d{5})?/, '$1 $2 $3')
                .replace(/\s\s/g, ' ')
                .trim()
                .substring(0, 17)
        );
        return;
    }
    $input.val(digits.replace(/(\d{4})(?=\d)/g, '$1 '));
}

export function otpFlag(checked) {
    return checked ? 'true' : 'false';
}

export function buildAddPaymentMethodPayload(fields, extras) {
    const cardValue = String(fields.card || '');
    const pan = cardValue.replace(/ /g, '');
    const cardType = fields.cardType || 'credit';
    const isDaf = cardType === 'pledger' || cardType === 'donors_fund' || cardType === 'ojc';
    const payload = {
        name: fields.name,
        card: pan,
        expiryMonth: fields.expiryMonth,
        expiryYear: fullExpiryYear(fields.expiryYear),
        cvv2: fields.cvv2,
        avs_zip: fields.avsZip,
        maskedCard: cardValue.slice(-4),
        use_otp: otpFlag(!!fields.useOtp),
        payment_type: 'new',
        daf_card_type: cardType,
        process_type: 'direct',
        save_card: 'true',
    };
    if (isDaf) {
        payload.daf_card = pan;
    }
    return Object.assign(payload, extras || {});
}

export function buildEditPaymentMethodPayload(fields, extras) {
    return Object.assign(
        {
            payment_type: 'saved',
            cc_id: fields.ccId,
            maskedCard: String(fields.lastFour || '').slice(-4),
            edit_card_name: fields.name,
            expiryMonth: fields.expiryMonth,
            expiryYear: fields.expiryYear,
            zip: fields.zip,
            use_otp: otpFlag(!!fields.useOtp),
        },
        extras || {}
    );
}

export function readAddFormValues(ids) {
    const $ = window.jQuery;
    return {
        name: $(ids.name).val(),
        card: $(ids.card).val(),
        expiryMonth: $(ids.expiryMonth).val(),
        expiryYear: $(ids.expiryYear).val(),
        cvv2: $(ids.cvv2).val(),
        avsZip: $(ids.avsZip).val(),
        useOtp: $(ids.useOtp).prop('checked'),
    };
}

export function readEditFormValues(ids) {
    const $ = window.jQuery;
    return {
        ccId: $(ids.ccId).val(),
        lastFour: $(ids.lastFour).val(),
        name: $(ids.name).val(),
        expiryMonth: $(ids.expiryMonth).val(),
        expiryYear: $(ids.expiryYear).val(),
        zip: $(ids.zip).val(),
        useOtp: $(ids.useOtp).prop('checked'),
    };
}
